import { IncompleteAppsActionButton } from '../../actions/IncompleteAppsActionButton';

export const actionCellRender = (e) => {
    return (
        <IncompleteAppsActionButton
            data={e.data}
            parentElementId='incompleteAppId'
        />
    );
};
